import React, { FC, useContext, useEffect } from 'react';
import { tiles } from '../../assets/tiles';
import { DateTime } from './DateTime';
import { ImageUploader } from './ImageUploader';
import * as S from './styles';
import { ThemeContext } from 'styled-components';
import { ThemeEnum } from '../../handlers/ThemeHandler';
import { useTour } from '@reactour/tour';
import { TutorialContext, TutorialEnum } from '../../handlers/TutorialHandler';
import TutorialLogo from '../../assets/IHR-Logo.png';
import BrandLogo from '../../assets/logo-ui-landscape-1.png';
import {
  LanguagesEnum,
  TranslationContext
} from '../../handlers/TranslationsHandler';

interface ITileContent {
  name: string;
}

export const TileContent: FC<ITileContent> = ({ name }) => {
  const theme =
    ThemeEnum[(useContext(ThemeContext) as any).theme || ThemeEnum.light];
  const themeContext = useContext(ThemeContext) as any;
  const language = useContext(TranslationContext).language || LanguagesEnum.DE;

  const inputFileRef = React.useRef(null);

  const { tutorialType } = useContext(TutorialContext);
  const { currentStep, isOpen } = useTour();

  useEffect(() => {
    currentStep === 1 &&
      tutorialType === TutorialEnum.two &&
      themeContext.setLogo(TutorialLogo);

    !isOpen &&
      tutorialType === TutorialEnum.two &&
      themeContext.setLogo(BrandLogo);
  }, [currentStep]);

  const uploadImage = () => {
    if (name === 'logo') {
      const inputEl = inputFileRef?.current;
      if (inputEl) {
        (inputEl as any)?.click();
      }
    }
  };

  if (name === 'real-date-time') {
    return <DateTime />;
  }

  return (
    <>
      <S.Image
        isLogoTile={name === 'logo'}
        onClick={uploadImage}
        src={
          name === 'logo' && themeContext.logo
            ? themeContext.logo
            : tiles[theme][language][name]
        }
        className={
          name === 'pulse' || name === 'logo' ? 'tile-static-img-styles' : ''
        }
      />
      {name === 'logo' && (
        <ImageUploader
          inputFileRef={inputFileRef}
          setSelectedImage={themeContext.setLogo}
        />
      )}
    </>
  );
};
